import Box from '@mui/material/Box';
import React, { useCallback, useState } from 'react';
import { useTranslation } from 'react-i18next';
import CircularProgress from '@mui/material/CircularProgress';
import Alert from '@mui/lab/Alert';
import Title from '../Title';
import { useNodeDataToSave } from './fields/hooks/useNodeDataToSave';
import CronInput from '../../../../CronGenerator/CronInput';

const DEFAULT_VALUE = '* * * * *';

const Fallback = () => (
  <Box display="flex" justifyContent="center">
    <CircularProgress size={24} />
  </Box>
);

const ScheduledTriggerStep = () => {
  const [nodeDataToSave, updateDataToSave] = useNodeDataToSave();
  const { t } = useTranslation();
  const [value, setValue] = useState(() => nodeDataToSave?.cron ?? DEFAULT_VALUE);

  const setCron = useCallback(
    (text) => {
      setValue(text);
      updateDataToSave({ ...nodeDataToSave, cron: text });
    },
    [updateDataToSave, nodeDataToSave]
  );

  const [error, onError] = useState();

  return (
    <Box component="section">
      <Title>{t('Schedule')}</Title>

      <Box display="flex" alignItems="center" my="16px">
        <Box mt="16px" width="100%">
          <React.Suspense fallback={<Fallback />}>
            <CronInput value={value} onChange={setCron} onError={onError} />
          </React.Suspense>
        </Box>
      </Box>
      {error && <Alert severity="error">{error.description}</Alert>}
    </Box>
  );
};

export default ScheduledTriggerStep;
